/**
 * schemas.js — four site-global JSON-LD schemas.
 * Rendered by RootLayout on every route.
 * Per-route schemas (Service, BreadcrumbList, FAQPage) live inline
 * in each route file — this module is only for the four global schemas.
 */
import { faqItems } from './faq.js';

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: "The Artificer's AI",
  url: 'https://www.artificersai.com',
  logo: 'https://www.artificersai.com/logos/artificers-logo-black.png',
  description:
    'Perth-based AI transformation partners. Custom AI systems and structured training programmes.',
  email: 'headartificer@artificersai.com',
  telephone: '+61433987271',
  areaServed: { '@type': 'Country', name: 'Australia' },
};

export const personSchema = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  '@id': 'https://artificersai.com/#sakib',
  name: 'Sakib Rahman',
  jobTitle: 'Founder',
  worksFor: { '@type': 'Organization', name: "The Artificer's AI" },
  url: 'https://www.artificersai.com',
};

/** Descriptions sourced from 03-offers.md spec — not the short homepage card copy */
export const serviceFoundrySchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'The Foundry',
  description:
    'A six-week founder cohort. Five founders per run. Build production-grade AI systems into your business alongside four other founders and walk out with the capability to keep building as the AI landscape evolves.',
  provider: { '@type': 'Organization', name: "The Artificer's AI" },
  areaServed: [
    { '@type': 'Country', name: 'Australia' },
    { '@type': 'AdministrativeArea', name: 'Global' },
  ],
  serviceType: 'AI founder cohort',
};

export const serviceAutomatedSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Fully Automated Business Systems',
  description:
    'Targeted AI automation for bounded operational pain. Email triage, invoice processing, voice AI for inbound calls, project management overhauls, net-new platform MVPs, and single-integration builds. PRD locked at signing, milestone-based delivery, source code delivered on completion.',
  provider: { '@type': 'Organization', name: "The Artificer's AI" },
  areaServed: { '@type': 'Country', name: 'Australia' },
  serviceType: 'Custom AI automation',
};

export const serviceTrainingSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Enterprise AI Training',
  description:
    'One-session AI training curriculum for teams. Claude basics, custom tool use, Claude Projects and MCPs, ethics and gotchas. Rinseable across multiple teams. 10-seat minimum per session. On-site or virtual.',
  provider: { '@type': 'Organization', name: "The Artificer's AI" },
  areaServed: { '@type': 'Country', name: 'Australia' },
  serviceType: 'Enterprise AI training',
};

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: "The Artificer's AI",
  url: 'https://www.artificersai.com',
  telephone: '+61433987271',
  email: 'headartificer@artificersai.com',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Perth',
    addressRegion: 'WA',
    postalCode: '6000',
    addressCountry: 'AU',
  },
  areaServed: { '@type': 'Country', name: 'Australia' },
};

export const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: "The Artificer's AI",
  url: 'https://www.artificersai.com',
};
